module.exports = __webpack_public_path__ + "img/page4Img1.47be4f12.png";